import React, { useEffect, useState } from 'react';
import { DocumentDownloadConsent } from '@/components/legal/DocumentDownloadConsent';

export const DownloadConsentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState('');
  const [resolver, setResolver] = useState<((accepted: boolean) => void) | null>(null);

  useEffect(() => {
    const handleShowConsent = (event: CustomEvent) => {
      const { fileName: eventFileName, resolve } = event.detail;
      setFileName(eventFileName);
      setResolver(() => resolve);
      setIsOpen(true);
    };

    window.addEventListener('show-download-consent', handleShowConsent as EventListener);

    return () => {
      window.removeEventListener('show-download-consent', handleShowConsent as EventListener);
    };
  }, []);

  const handleAccept = () => {
    if (resolver) {
      resolver(true);
      setResolver(null);
    }
  };

  const handleCancel = (open: boolean) => {
    if (!open && resolver) {
      resolver(false);
      setResolver(null);
    }
    setIsOpen(open);
  };

  return (
    <>
      {children}
      <DocumentDownloadConsent
        open={isOpen}
        onOpenChange={handleCancel}
        onAccept={handleAccept}
        documentName={fileName}
      />
    </>
  );
};